import { ActionReducerMap, Store } from '@ngrx/store';
import { INewThridPartyState, NewThirdPartyClaimReducer } from './third-party-claim.reducer';
import { User } from '../services/auth.service';
import { currentUserReducer } from './current-user.reducer';
import { printReducer, PrintState } from './print.reducer';
import { AppParamsReducer, AppParamState, AppParamsActions } from './app-params.reducer';
import { fullScreenReducer, FullScreenState } from './full-screen.reducer';
import { AppReducer, AppState } from './app.reducer';
import { Breadcrumb } from '../domain/breadcrumb.entity';
import { breadcrumbReducer } from './breadcrumb.reducer';
import { AppSettingsReducer, AppSettingsState } from './app-settings.reducer';


export const USER_LOGGED_OUT = 'USER_LOGGED_OUT';

export const appReducer: ActionReducerMap<IState> = {
  breadcrumb: breadcrumbReducer,
  currentUser: currentUserReducer,
  appParams: AppParamsReducer,
  print: printReducer,
  fullScreen: fullScreenReducer,
  newThirdPartyClaim: NewThirdPartyClaimReducer,
  app: AppReducer,
  appSettings: AppSettingsReducer,
};

export interface IState {
  breadcrumb: Breadcrumb;
  currentUser?: User;
  appParams?: AppParamState;
  print?: PrintState;
  fullScreen?: FullScreenState;
  newThirdPartyClaim?: INewThridPartyState;
  app?: AppState;
  appSettings?: AppSettingsState;
}

export function initStores(store: Store<IState>) {
  store.dispatch({
    type: AppParamsActions.INIT,
  });
}
